import api from './client';

export const adminApi = {
  companies:     ()                          => api.get('/admin/companies'),
  approve:       (id: number)                => api.post(`/admin/companies/${id}/approve`),
  reject:        (id: number)                => api.post(`/admin/companies/${id}/reject`),
  getModules:    (id: number)                => api.get(`/admin/companies/${id}/modules`),
  setModules:    (id: number, modules: string[]) => api.post(`/admin/companies/${id}/modules`, { modules }),
  superAdmins:   ()                          => api.get('/admin/super-admins'),
  searchUsers:   (search: string)            => api.get('/admin/users-search', { params: { search } }),
  setSuperAdmin: (id: number, value: boolean) => api.post(`/admin/users/${id}/super-admin`, { value }),
};
